
import NavBar from "./components/NavBar.vue";
import { defineComponent } from "vue";
import { store } from "@/store";

export default defineComponent({
  components: {
    NavBar,
  },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {
    isLoggedIn: function () {
      return store.getters.getUserSession;
    },
  },
  methods: {},
});
